module.exports = __webpack_public_path__ + "static/pipeline-update-category_2-a411d8c2d731a7c84e980f3c69c417a9.png";